import SyllabusService from "../../services/Syllabus";
import { Syllabus } from "../../types";
import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

import { QUERY_KEY } from "./useListSyllabi";

export const makeQueryKey = (id?: Syllabus["id"]) => [QUERY_KEY, id];

function useFetchSyllabus(id?: Syllabus["id"]) {
  const key = makeQueryKey(id);

  return useAuthorizedQuery(
    key,
    () => {
      if (id) {
        return SyllabusService.fetchSyllabus(id);
      }

      throw new Error("syllabus id is required");
    },
    { enabled: !!id }
  );
}

export default useFetchSyllabus;
